import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import styles from './FeatureDetailCollections.module.scss';
import CollectionsPanel from '../../Panel/Collections';

const FeatureDetailCollections = (props) => {
  return (
    <div className={styles.collectionsContainer}>
      <CollectionsPanel />
    </div>
  );
};

FeatureDetailCollections.propTypes = {
  selectedFeature: PropTypes.object
};

export default connect((model) => ({
  selectedFeature: model.features.selectedFeature
}))(FeatureDetailCollections);